import { Component, OnInit } from '@angular/core';
import { CatalogoService } from '../../../services/catalogo/catalogo.service';
import { ConfigService } from '../../../services/config/config.service';
import { InventarioService } from '../../../services/inventario/inventario.service';
import { ProductoService } from '../../../services/producto/producto.service';
import { ReportesService } from '../../../services/reportes/reportes.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-inventario',
  templateUrl: './inventario.component.html',
  styleUrls: ['./inventario.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class InventarioComponent implements OnInit {

  loadMenu: boolean = true;
  load: boolean = false;
  listProducts: Array<any> = [];
  listProductsStore: Array<any> = []
  listProductsFilter: Array<any> = [];
  listRastreoProducto: Array<any> = [];
  listProductsPagination: Array<any> = [];
  empresa: Array<any> = [];
  infoUser: any = {};
  token: any;
  categorias: Array<any> = [];
  selectedCategory: any = {};
  selectedSubCategory: any = {};
  bloqueo: boolean = false;
  msgInicial: String = "";
  urlDownload: String = "";
  checkedUniqueInv: boolean = false;
  divFilter: boolean = false;
  viewRastreo: boolean = false;
  selectedProduct: any = {};
  divStoreSelection: boolean = false;
  listStores: Array<any> = [];
  selectedStore: any = {};
  subCategorias: Array<any> = [];
  subCategoriasN3: Array<any> = [];
  subCategoriasN4: Array<any> = [];
  first: number = 0;
  rows: number = 20;
  totalRecords: number = 0;

  constructor(private catalogo: CatalogoService,
    private producto: ProductoService,
    private reporte: ReportesService,
    private config: ConfigService,
    private inventario: InventarioService,
    private message: MessageService
  ) { }

  ngOnInit(): void {
    this.listProductsFilter = JSON.parse(localStorage.getItem("listProducts") ?? '[]');
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.empresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    // get stores information
    this.listStores = JSON.parse(localStorage.getItem('tiendas') ?? "[]");

    // obtener categoria de producto nivel 1
    this.producto.getCategorizacionNivel1(this.token.token).subscribe({
      next: (response) => {
        this.categorias = response as Array<any>;
      }, error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    });

    //saber si esta vinculado a una tienda
    if ((!this.empresa[0].tiendaEmpleados[0])) {
      if ((this.infoUser.idPerfil == 5)) {
        // en caso de no estar vinculado debe elegir la tienda o la ubicación
        this.bloqueo = true;
        this.msgInicial = '<div class="p-message p-message-info">No esta vinculado a una tienda, favor contactar a su administrador</div>';
      } else {
        // exigir la selección de una ubicación
        this.divStoreSelection = true;
      }

    } else {
      this.selectedStore = this.empresa[0].tiendaEmpleados[0];
      this.getInventarioStore();
    }

  }

  /// cargar información de inventario de la tienda
  getInventarioStore = () => {
    // carga de información de la tienda
    if (this.selectedStore?.idTienda > 0) {
      this.load = true;
      this.divStoreSelection = false;

      this.catalogo.getProductosTienda(this.token.token, this.selectedStore.idTienda).subscribe((response) => {
        this.listProductsStore = response as Array<any>;
        this.load = false;

        this.listProductsFilter.map((row: any) => {
          // modificar la ruta para que pueda visualizar la imagen
          if (row.productoImagenes.length > 0)
            row.productoImagenes[0].ubicacion = this.config.urlService + "Resources/Imagenes/" + row.productoImagenes[0].ubicacion;
        })

        this.listProducts = this.listProductsFilter;
        //localStorage.setItem("listProductsStore", JSON.stringify(this.listProductsStore));
        // leer el inventario
        this.listProductsFilter.map((row: any) => {
          var inv: any = this.listProductsStore.filter((item) => {
            return item.idProducto == row.idProducto
          })[0];
          row.inventario = inv.cantidadEnMano;

          if (!row.precioProducto)
            row.precioProducto = { precioPromocion: 0, precio: 0 }
        });

        // ********************* Paginación **************************
        this.listProductsPagination = this.listProductsFilter.slice(0, 20);
        this.totalRecords = this.listProductsFilter.length;

      });
    }
    else
      this.message.add({ severity: 'info', detail: 'Favor elija una localización de inventario' })

  }


  // importar categorias de n niveles
  getCategoriaNivelN: any = (nivel: number, idCategoriaM: number) => {
    return new Promise((resolve, reject) => {
      if (!!idCategoriaM)
        this.producto.getCategorizacionNivelN(this.token.token, idCategoriaM).subscribe({
          next: (response) => {
            switch (nivel) {
              case 2:
                this.subCategorias = response as Array<any>;
                this.subCategoriasN3 = [];
                this.subCategoriasN4 = [];
                break;
              case 3:
                this.subCategoriasN3 = response as Array<any>;
                this.subCategoriasN4 = [];
                break;
              case 4:
                this.subCategoriasN4 = response as Array<any>;
                break;
            }
            resolve(true);
          },
          error: (error: HttpErrorResponse) => { this.config.handleError(error) }
        });
    })

  }

  filter = (query: string) => {
    this.listProductsFilter = this.listProducts.filter(row => {
      return ((row.descripcionLarga.toLowerCase().indexOf(query.toLowerCase()) > -1)
        || (row.identificador.toString().toLowerCase().indexOf(query.toLowerCase()) > -1)
        || (row.codBarras.toLowerCase().indexOf(query.toLowerCase()) > -1))
    });
    this.listProductsPagination = this.listProductsFilter.slice(0, 20);
    this.totalRecords = this.listProductsFilter.length;
  }

  redirigir = () => {
    window.location.href = "Begin";
  }

  getReporte = () => {
    this.load = true;
    this.reporte.getInventario(this.token.token, this.empresa[0].idProveedor, this.selectedStore.idTienda, this.infoUser.empleadoProveedors[0].idEmpleadoProveedor, 'EXCEL').subscribe({
      next: (response) => {
        this.urlDownload = this.config.urlService.toString() + (response as String);
        this.load = false;
      }, error: (error: Response) => {
        this.load = false;
        this.msgInicial = '<div class="p-message p-message-info">Se ha presentado un error, favor intente de nuevo</div>';
      }
    })
  }



  //obtener el rstreo de los productos
  getRastreoProducto = (row: any) => {
    this.selectedProduct = {};
    this.viewRastreo = true;
    var lastItem = -1;
    // saber si el producto ya esta en el array
    var exists = this.listRastreoProducto.findIndex((item) => {
      return row.idProducto == item.idProducto
    });

    if (exists > -1) {
      lastItem = (this.listRastreoProducto[exists].movimientoTienda.length - 1)
    }
    this.inventario.getRastreoProducto(this.token.token, row.idProducto, this.selectedStore.idTienda, exists > -1 ? this.listRastreoProducto[exists].movimientoTienda[lastItem].idMovimientoTienda : 0).subscribe((response: any) => {
      if (exists == -1)
        this.listRastreoProducto.push({
          idProducto: response[0].idProducto,
          descripcionLarga: row.descripcionLarga,
          codBarras: row.codBarras,
          movimientoTienda: response[0].movimientoTienda

        })
      else
        Array.prototype.push.apply(this.listRastreoProducto[exists].movimientoTienda, response[0].movimientoTienda);

      this.selectedProduct = this.listRastreoProducto.filter((item) => {
        return row.idProducto == item.idProducto
      })[0];

    })
  }

  onPageChange = (event: any) => {
    this.first=0;
    this.listProductsPagination = this.listProductsFilter.slice(event.first, (event.page + 1) * this.rows);
    this.totalRecords = this.listProductsFilter.length;
  }

}
